<script>
import BaseDialog from "@/components/dialogs/baseDialog.vue";

export default {
  name: "BaseUpsertDialog",
  extends: BaseDialog,
  data: function() {
    return {
      entityName: ""
    };
  },
  computed: {
    entity: {
      get() {
        return null;
      }
    },
    title: {
      get() {
        return `${this.entity ? "Update" : "Create new"} ${this.entityName}${
          this.entity && this.entity.name ? ` - ${this.entity.name}` : ""
        }`;
      }
    },
    instructions: {
      get() {
        return `Please use this form to ${
          this.entity ? "update the " : "create a new"
        } ${this.entityName}`;
      }
    }
  },

  methods: {
    copyValues() {
      if (this.entity) {
        Object.keys(this.$data).forEach(key => {
          if (this.entity[key]) {
            this[key].value = this.entity[key];
          }
        });
        this.customCopyValues();
      }
    },
    // Override this to specify custom copy operations from the entity to the input values
    customCopyValues() {}
  },
  watch: {
    entity() {
      this.copyValues();
    }
  },
  created() {
    this.copyValues();
  }
};
</script>


// WEBPACK FOOTER //
// baseUpsertDialog.vue?293fefe6